import { MaterialReactTable } from 'material-react-table'

import { PageWrap } from '@/components'
import { useTable } from '@/hooks'
import { DependenciesBottomToolbar } from '@/pages/User/pages/Home/components/Dependencies/components/DependenciesBottomToolbar'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { useSelectedBranchNumericId } from '@/pages/User/pages/Home/components/TreePanel/TreePanelContext'
import { useGetNodeRelationsRelationQuery } from '@/rtkApi'
import { RelationDto } from '@/rtkApi/mddApiSliceGeneratedV2'

import { useDepColumns } from './hooks'

export const NewDependencies = () => {
	const {
		state: { editMode, node },
	} = useDetailTabContext()
	const branchId = useSelectedBranchNumericId()

	const { data, isLoading, refetch } = useGetNodeRelationsRelationQuery(
		{
			branchId: branchId as number,
			structureId: node.id,
		},
		{ skip: branchId == null },
	)

	const columns = useDepColumns()

	const table = useTable<RelationDto>({
		columns,
		data: data || [],
		editMode,
		options: {
			displayColumnDefOptions: {
				'mrt-row-expand': {
					header: '',
					maxSize: 42,
					minSize: 42,
					size: 42,
				},
			},
			enableExpandAll: true,
			enableExpanding: true,
			enableRowActions: false,
			enableRowOrdering: false,
			getSubRows: (row) => row.children,
			initialState: {
				density: 'compact',
				expanded: true,
				showColumnFilters: false,
				showGlobalFilter: false,
			},
			muiTableBodyRowProps: ({ row }) => {
				const isChild = row.depth > 0
				const hasChildren = (row.subRows?.length ?? 0) > 0

				return {
					sx: {
						backgroundColor: hasChildren ? '#f7f8fa' : undefined,
						height: 40,
						'& > td': {
							borderBottomColor: isChild ? '#f0f1f3' : undefined,
						},
					},
				}
			},
			state: {
				isLoading,
			},
			renderBottomToolbar: (
				<DependenciesBottomToolbar
					node={node}
					refetch={refetch}
					editMode={editMode}
				/>
			),
			enableTopToolbar: true,
			enableGlobalFilter: true,
		},
	})

	return (
		<PageWrap>
			<MaterialReactTable table={table} />
		</PageWrap>
	)
}
